// import React, { useState } from 'react';
// import {
//   Box,
//   VStack,
//   HStack,
//   Text,
//   Button,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   IconButton,
//   Badge,
//   useColorModeValue,
//   Heading,
//   Card,
//   CardBody,
//   InputGroup,
//   InputLeftElement,
//   Input,
//   Flex,
//   Tabs,
//   TabList,
//   TabPanels,
//   TabPanel,
//   Tab,
//   useDisclosure,
//   Drawer,
//   DrawerOverlay,
//   DrawerContent,
//   DrawerCloseButton,
//   DrawerHeader,
//   DrawerBody,
//   FormControl,
//   FormLabel,
// } from '@chakra-ui/react';
// import { AddIcon, DeleteIcon, SearchIcon } from '@chakra-ui/icons';

// const dummyUsers = [
//   { id: 1, name: 'Alice Johnson', email: 'alice@example.com', role: 'Associate', status: 'active', joinDate: '2024-01-10', userId: 'USR001' },
//   { id: 2, name: 'Bob Smith', email: 'bob@example.com', role: 'Finance', status: 'inactive', joinDate: '2024-02-15', userId: 'USR002' },
// ];

// const Users: React.FC = () => {
//   const [users, setUsers] = useState(dummyUsers);
//   const [showOnboardTab, setShowOnboardTab] = useState(false);
//   const [newUser, setNewUser] = useState({ name: '', email: '', role: '', status: 'active', joinDate: '', userId: '' });
//   const [searchTerm, setSearchTerm] = useState('');

//   const cardBg = useColorModeValue('white', 'gray.800');
//   const borderColor = useColorModeValue('gray.200', 'gray.700');

//   const handleAddUser = () => {
//     setUsers([...users, { ...newUser, id: users.length + 1 }]);
//     setNewUser({ name: '', email: '', role: '', status: 'active', joinDate: '', userId: '' });
//     setShowOnboardTab(false);
//   };

//   const handleDeleteUser = (id: number) => {
//     setUsers(users.filter(u => u.id !== id));
//   };

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case 'active':
//         return 'green';
//       case 'inactive':
//         return 'gray';
//       case 'onboarding':
//         return 'blue';
//       default:
//         return 'gray';
//     }
//   };

//   const filteredUsers = users.filter(user =>
//     user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     user.role.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <Box>
//       {/* Page Header */}
//       <Box mb={8}>
//         <Heading size="lg" color="gray.800" mb={2}>
//           Users
//         </Heading>
//         <Text color="gray.600">
//           Onboard and manage your users
//         </Text>
//       </Box>

//       {/* Actions and Search */}
//       <Box mb={6}>
//         <Flex gap={4} align="center" justify="space-between">
//           <Button
//             leftIcon={<AddIcon />}
//             colorScheme="primary"
//             onClick={() => setShowOnboardTab(!showOnboardTab)}
//             className="btn-primary"
//           >
//             Onboard User
//           </Button>
//           <InputGroup maxW="400px">
//             <InputLeftElement pointerEvents="none">
//               <SearchIcon color="gray.400" />
//             </InputLeftElement>
//             <Input
//               placeholder="Search users..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="form-input"
//             />
//           </InputGroup>
//         </Flex>
//       </Box>

//       {/* Onboard User Tab */}
//       {showOnboardTab && (
//         <Box mb={6}>
//           <Card bg={cardBg} border="1px" borderColor={borderColor}>
//             <CardBody>
//               <Heading size="md" mb={4}>Onboard User</Heading>
//               <Flex gap={4} flexWrap="wrap">
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>Name</FormLabel>
//                   <Input value={newUser.name} onChange={e => setNewUser({ ...newUser, name: e.target.value })} />
//                 </FormControl>
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>Email</FormLabel>
//                   <Input value={newUser.email} onChange={e => setNewUser({ ...newUser, email: e.target.value })} />
//                 </FormControl>
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>Role</FormLabel>
//                   <Input value={newUser.role} onChange={e => setNewUser({ ...newUser, role: e.target.value })} />
//                 </FormControl>
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>Status</FormLabel>
//                   <Input value={newUser.status} onChange={e => setNewUser({ ...newUser, status: e.target.value })} />
//                 </FormControl>
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>Join Date</FormLabel>
//                   <Input type="date" value={newUser.joinDate} onChange={e => setNewUser({ ...newUser, joinDate: e.target.value })} />
//                 </FormControl>
//                 <FormControl mb={4} flex={1} minW="220px">
//                   <FormLabel>User ID</FormLabel>
//                   <Input value={newUser.userId} onChange={e => setNewUser({ ...newUser, userId: e.target.value })} />
//                 </FormControl>
//               </Flex>
//               <Button colorScheme="blue" onClick={handleAddUser} w="full">
//                 Add User
//               </Button>
//             </CardBody>
//           </Card>
//         </Box>
//       )}

//       {/* Users Table - Responsive */}
//       <Card bg={cardBg} border="1px" borderColor={borderColor}>
//         <CardBody p={0}>
//           <Box overflowX="auto">
//             <Table variant="simple" minWidth="800px">
//               <Thead>
//                 <Tr>
//                   <Th className="table-header" minWidth="100px" maxWidth="150px">User ID</Th>
//                   <Th className="table-header" minWidth="150px" maxWidth="200px">Name</Th>
//                   <Th className="table-header" minWidth="120px" maxWidth="150px">Role</Th>
//                   <Th className="table-header" minWidth="180px" maxWidth="220px">Contact</Th>
//                   <Th className="table-header" minWidth="100px" maxWidth="120px">Status</Th>
//                   <Th className="table-header" minWidth="120px" maxWidth="150px">Join Date</Th>
//                   <Th className="table-header" minWidth="100px" maxWidth="120px">Actions</Th>
//                 </Tr>
//               </Thead>
//               <Tbody>
//                 {filteredUsers.map((user) => (
//                   <Tr key={user.id}>
//                     <Td className="table-cell" minWidth="100px" maxWidth="150px">
//                       <Text fontWeight="medium" color="primary.600" isTruncated>
//                         {user.userId}
//                       </Text>
//                     </Td>
//                     <Td className="table-cell" minWidth="150px" maxWidth="200px">
//                       <VStack align="start" spacing={1}>
//                         <Text fontWeight="medium" isTruncated>{user.name}</Text>
//                         <Text fontSize="sm" color="gray.500" isTruncated>
//                           {user.email}
//                         </Text>
//                       </VStack>
//                     </Td>
//                     <Td className="table-cell" minWidth="120px" maxWidth="150px">{user.role}</Td>
//                     <Td className="table-cell" minWidth="180px" maxWidth="220px" isTruncated>{user.email}</Td>
//                     <Td className="table-cell" minWidth="100px" maxWidth="120px">
//                       <Badge
//                         colorScheme={getStatusColor(user.status)}
//                         variant="subtle"
//                       >
//                         {user.status}
//                       </Badge>
//                     </Td>
//                     <Td className="table-cell" minWidth="120px" maxWidth="150px">{user.joinDate}</Td>
//                     <Td className="table-cell" minWidth="100px" maxWidth="120px">
//                       <HStack spacing={2}>
//                         {/* View/Edit actions can be added here */}
//                         <IconButton
//                           aria-label="Delete user"
//                           icon={<DeleteIcon />}
//                           size="sm"
//                           variant="ghost"
//                           colorScheme="red"
//                           onClick={() => handleDeleteUser(user.id)}
//                         />
//                       </HStack>
//                     </Td>
//                   </Tr>
//                 ))}
//               </Tbody>
//             </Table>
//           </Box>
//         </CardBody>
//       </Card>
//     </Box>
//   );
// };

// export default Users;

import React, { useState, useEffect } from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Badge,
  useColorModeValue,
  Heading,
  Card,
  CardBody,
  InputGroup,
  InputLeftElement,
  Input,
  Flex,
  useToast,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon, SearchIcon, EditIcon, RepeatIcon, EmailIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import {
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import { userAPI, User } from '../services/api';

const statusOptions: User['status'][] = ['active', 'inactive'];

const Users: React.FC = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showOnboardTab, setShowOnboardTab] = useState(false);
  const [newUser, setNewUser] = useState<Omit<User, '_id'>>({
    name: '',
    email: '',
    role: '',
    status: 'active',
    joinDate: '',
  });
  const [editUser, setEditUser] = useState<User | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  // Initial load
  useEffect(() => {
    userAPI
      .getAllUsers()
      .then((res: any) => {
        // console.log('Decrypted users response:', res.data);
        if (Array.isArray(res.data)) {
          setUsers(res.data);
        } else if (Array.isArray(res.data?.data)) {
          setUsers(res.data.data);
        } else if (typeof res.data === 'object' && res.data !== null && Object.keys(res.data).length === 0) {
          setUsers([]);
        } else {
          setUsers([]);
        }
      })
      .catch(() => setUsers([]));
  }, []);

  // Debounced search to backend
  useEffect(() => {
    const handle = setTimeout(() => {
      userAPI
        .getAllUsers(searchTerm)
        .then((res: any) => {
          // console.log('Decrypted users response:', res.data);
          if (Array.isArray(res.data)) {
            setUsers(res.data);
          } else if (Array.isArray(res.data?.data)) {
            setUsers(res.data.data);
          } else if (typeof res.data === 'object' && res.data !== null && Object.keys(res.data).length === 0) {
            setUsers([]);
          } else {
            setUsers([]);
          }
        })
        .catch(() => setUsers([]));
    }, 400);
    return () => clearTimeout(handle);
  }, [searchTerm]);

  // Delete User
  const handleDeleteUser = async (id: string) => {
    try {
      await userAPI.softDeleteUser(id);
      setUsers(users.filter(u => u._id !== id));

      toast({
        title: 'User Deleted',
        description: 'The user has been removed successfully.',
        status: 'info',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
    } catch (error: any) {
      toast({
        title: 'Failed to delete user',
        description: error.response?.data?.message || 'Something went wrong.',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
    }
  };

  const handleOnboardUser = () => {
    navigate('/users/onboard');
  };

  const handleEditUser = (user: User) => {
    if (user._id) {
      navigate(`/users/edit/${user._id}`);
    }
  };

  const toggleStatus = async (user: User) => {
    const id = user._id;
    const newStatus = user.status === 'active' ? 'inactive' : 'active';
    if (!id) {
      toast({
        title: 'Error',
        description: 'User id is missing.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    try {
      await userAPI.updateUser(id, { status: newStatus });
      setUsers(prev => prev.map(u => (u._id === id ? { ...u, status: newStatus } : u)));
      toast({
        title: 'Status updated',
        description: `${user.name} is now ${newStatus}.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (err: any) {
      toast({
        title: 'Error',
        description: 'Failed to update user status. Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'green';
      case 'inactive':
        return 'gray';
      case 'onboarding':
        return 'blue';
      default:
        return 'gray';
    }
  };

  // Server-side filtering now; keep fallback filter if needed later
  const filteredUsers = users;

  // Function to format date to day-month-year
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Box>
      {/* Page Header */}
      <Box mb={8}>
        <Heading size="lg" color="gray.800" mb={2}>
          Users
        </Heading>
        <Text color="gray.600">Onboard and manage your users</Text>
      </Box>

      {/* Actions and Search */}
      <Box mb={6}>
        <Flex gap={4} align="center" justify="space-between">
          <Button
            leftIcon={<AddIcon />}
            colorScheme="primary"
            onClick={handleOnboardUser}
          >
            Onboard User
          </Button>
          <InputGroup maxW="400px">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Search users..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Flex>
      </Box>

      {/* Users Table */}
      <Card bg={cardBg} border="1px" borderColor={borderColor}>
        <CardBody p={0}>
          <Box overflowX="auto">
            <Table variant="simple" minWidth="800px">
              <Thead>
                <Tr>
                  <Th>User ID</Th>
                  <Th>Name</Th>
                  <Th>Role</Th>
                  <Th>Contact</Th>
                  <Th>Status</Th>
                  <Th>Join Date</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredUsers.length === 0 ? (
                  <Tr>
                    <Td colSpan={7}>
                      <Text textAlign="center" color="gray.500">
                        {searchTerm.trim()
                          ? `No users found for "${searchTerm.trim()}"`
                          : 'No users found'}
                      </Text>
                    </Td>
                  </Tr>
                ) : (
                  filteredUsers.map(user => (
                    <Tr key={user._id}>
                      <Td>
                        <Text fontWeight="medium" color="primary.600" isTruncated>
                          {user._id}
                        </Text>
                      </Td>
                      <Td>
                        <VStack align="start" spacing={1}>
                          <Text fontWeight="medium" isTruncated>
                            {user.name}
                          </Text>
                        </VStack>
                      </Td>
                      <Td>{user.role}</Td>
                      <Td isTruncated>
                        <HStack spacing={1}>
                          <EmailIcon color="gray.500" boxSize={4} />
                          <Menu>
                            <MenuButton as={Text} color="blue.500" textDecoration="underline" cursor="pointer">
                              {user.email}
                            </MenuButton>
                            <MenuList>
                              <MenuItem as="a" href={`mailto:${user.email}`}>Default Mail Client</MenuItem>
                              <MenuItem as="a" href={`https://mail.google.com/mail/?view=cm&fs=1&to=${user.email}`} target="_blank">Gmail</MenuItem>
                              <MenuItem as="a" href={`https://outlook.live.com/mail/0/deeplink/compose?to=${user.email}`} target="_blank">Outlook</MenuItem>
                            </MenuList>
                          </Menu>
                        </HStack>
                      </Td>
                      <Td textAlign="center">
                        <Badge
                          colorScheme={getStatusColor(user.status)}
                          variant="subtle"
                          px={3}
                          py={1}
                          textTransform="capitalize"
                          fontSize="sm"
                          borderRadius="md"
                          minW="80px"
                          textAlign="center"
                          display="inline-block"
                        >
                          {user.status}
                        </Badge>
                      </Td>
                      <Td>{user.joinDate ? user.joinDate.slice(0, 10) : ''}</Td>
                      {/* <Td>{formatDate(user.joinDate)}</Td> */}
                      <Td>
                        <HStack spacing={2}>
                          <IconButton
                            aria-label="Toggle status"
                            icon={<RepeatIcon />}
                            size="sm"
                            variant="ghost"
                            onClick={() => toggleStatus(user)}
                            title={user.status === 'active' ? 'Deactivate' : 'Activate'}
                            sx={{ color: user.status === 'active' ? 'red' : 'green' }}
                          />
                          <IconButton
                            aria-label="Edit user"
                            icon={<EditIcon />}
                            size="sm"
                            variant="ghost"
                            colorScheme="blue"
                            onClick={() => handleEditUser(user)}
                          />
                          <IconButton
                            aria-label="Delete user"
                            icon={<DeleteIcon />}
                            size="sm"
                            variant="ghost"
                            colorScheme="red"
                            onClick={() => {
                              if (user._id) handleDeleteUser(user._id);
                              else {
                                toast({
                                  title: 'Error',
                                  description: 'User id missing, cannot delete.',
                                  status: 'error',
                                  duration: 3000,
                                  isClosable: true,
                                });
                              }
                            }}
                          />
                        </HStack>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </Box>
        </CardBody>
      </Card>

    </Box>
  );
};

export default Users;
